module.exports = __webpack_public_path__ + "img/password.e7dcdab5.svg";